module.exports = __webpack_public_path__ + "img/aParty_1208_E.99b0650a.jpg";